"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleModal = exports.getModalPropsByActionId = void 0;
const next_utils_constants_1 = require("@gerenciatd/next.utils.constants");
const next_utils_common_1 = require("@gerenciatd/next.utils.common");
const dynamic_1 = __importDefault(require("next/dynamic"));
const SupportAndSearch = (0, dynamic_1.default)(() => Promise.resolve().then(() => __importStar(require('./SupportAndSearch'))));
const LoginContent = (0, dynamic_1.default)(() => Promise.resolve().then(() => __importStar(require('./Login'))));
const MoreOptionsContent = (0, dynamic_1.default)(() => Promise.resolve().then(() => __importStar(require('./MoreOptionsContent'))));
const getModalPropsByActionId = (actionID, modalProps) => {
    const currentDevice = (0, next_utils_common_1.getDeviceKindDependsOnViewPort)();
    let componentProps = {};
    let result = {
        contentPosition: 'center--top',
        opacityLayoutColor: 'white',
        inSceneEffect: 'fadeIn',
        outSceneEffect: 'fadeOut',
        closeByClickingOutside: true,
    };
    /* those come from JSON INFO */
    if (actionID === 'support' && modalProps && modalProps.support) {
        if (modalProps.support.modalProperties) {
            result = modalProps.support.modalProperties;
        }
        const currentComponentProps = Object.assign({}, modalProps.support);
        delete currentComponentProps.modalProperties;
        componentProps = currentComponentProps;
    }
    if (actionID === 'search' && modalProps && modalProps.search) {
        if (modalProps.search.modalProperties) {
            result = modalProps.search.modalProperties;
        }
        const currentComponentProps = Object.assign({}, modalProps.search);
        delete currentComponentProps.modalProperties;
        componentProps = currentComponentProps;
        result = Object.assign(Object.assign({}, result), { contentPosition: 'center--top', opacityLayoutColor: 'black05', inSceneEffect: 'fadeIn', outSceneEffect: 'fadeOut', closeByClickingOutside: true });
    }
    if (actionID === 'login' &&
        modalProps &&
        modalProps.login &&
        modalProps.login.modalProperties) {
        result = Object.assign({}, modalProps.login.modalProperties);
        if (currentDevice === next_utils_constants_1.DEVICES.MOBILE) {
            result = Object.assign(Object.assign({}, result), { contentPosition: result.contentPositionMobile, inSceneEffect: result.inSceneEffectMobile, outSceneEffect: result.outSceneEffectMobile });
        }
        const currentComponentProps = Object.assign({}, modalProps.login);
        delete currentComponentProps.modalProperties;
        componentProps = currentComponentProps;
        result = Object.assign(Object.assign({}, result), { closeByClickingOutside: true });
    }
    /* DEVS MODALS, THOSE THERE ARE NOT IN JSON  */
    if (actionID === 'opciones') {
        result = Object.assign(Object.assign({}, result), { contentPosition: 'center--bottom', opacityLayoutColor: 'black05', inSceneEffect: 'fadeInBottom', outSceneEffect: 'fadeOutBottom', closeByClickingOutside: true });
    }
    // TODO sondar !!
    return { modalProps: result, componentProps };
};
exports.getModalPropsByActionId = getModalPropsByActionId;
const handleModal = (actionID, modalProps, props, addModal) => {
    let taggingInfo = null;
    let isPriority = null;
    if (props && props.taggingInfo && props.isPriority) {
        ({ taggingInfo, isPriority } = props);
    }
    const ModalDataFromRedux = (0, exports.getModalPropsByActionId)(actionID, modalProps);
    let { componentProps } = ModalDataFromRedux;
    const { modalProps: currentModalProps } = ModalDataFromRedux;
    // if we could not get component props  from JSON for modal we got initials
    if (componentProps && Object.keys(componentProps).length === 0) {
        componentProps = props;
    }
    if (actionID !== 'login' && actionID !== 'opciones') {
        const idSearch = 'supportOrSearch';
        addModal({
            type: 'MODAL',
            id: idSearch,
            Element2Show: SupportAndSearch,
            modalProps: Object.assign(Object.assign({}, currentModalProps), { contentInsideContainer: false }),
            elementProps: Object.assign(Object.assign({}, componentProps), { isPriority, kind: actionID, taggingInfo }),
        });
    }
    if (actionID === 'login') {
        const idLogin = 'login';
        addModal({
            type: 'MODAL',
            id: idLogin,
            Element2Show: LoginContent,
            modalProps: currentModalProps,
            elementProps: Object.assign({}, componentProps),
        });
    }
    if (actionID === 'opciones') {
        const idOpciones = 'options';
        addModal({
            type: 'MODAL',
            id: idOpciones,
            Element2Show: MoreOptionsContent,
            modalProps: currentModalProps,
            elementProps: Object.assign({}, componentProps),
        });
    }
    // TODO sondar !!
};
exports.handleModal = handleModal;
//# sourceMappingURL=utils.js.map